<template>
    <div class="col-custom-row">
        <div class="col-custom-3-12 between-md-lg">
            <card :padding="false" class="no-padding">
                <div class="col-lg-12 account-performance__metric--highlight" :style="organizationBackgroundColor">
                    <div class="row">
                        <div class="col-lg-12 account-performance__container" :class="{mock: !accountSpendLoaded}">
                            <span class="account-performance__metric--value" v-html="spend"/>
                            <span class="account-performance__metric--text" v-text="$t('googleAdWords.adViewer.spend')"/>
                        </div>
                    </div>
                </div>
            </card>
        </div>

        <div class="col-custom-9-12 between-md-lg metrics-overview">
            <card :padding="false" class="no-padding">
                <template v-if="accountSpendLoaded" >
                    <div class="metrics-grid">
                      <div class="col-sm-2 account-performance__metric--normal"
                           v-for="value in metrics"
                           v-if="value.metric !== 'spend'"
                      >
                        <span class="account-performance__metric--value" v-html="insights[value.metric]"/>
                        <span class="account-performance__metric--text"
                              v-text="$t(`facebook.ads.insights.${value.metric}`)"
                        />
                      </div>
                    </div>
                </template>

                <div class="col-lg-12" style="min-height: 111px;" v-else>
                    <logo-loader/>
                </div>
            </card>
        </div>
    </div>
</template>


<style lang="scss">
    .account-performance__metric--value .accountCurrency {
        margin-left: 5px;
        font-size: 70%;
    }
</style>

<style lang="scss" scoped>
    @import "~@/assets/scss/_vars.scss";
    @import "~@/assets/scss/_mixins.scss";

    .no-padding {
        padding: 0;

        > .row {
            margin: 0;
        }
    }

    .account-performance__metric--highlight {
        color: #ffffff;
        text-align: center;
        margin: 0;
        border-radius: 4px;

        .account-performance__container {
            @include ellipsis;
            padding: 27px 20px;

            .account-performance__metric--value {
                font-weight: 700;
                font-size: 26px;
                margin: 0;
            }

            .account-performance__metric--text {
                display: block;
            }
        }
    }

    .account-performance__metric--normal {
        min-height: 111px;
        padding: 27px 30px 0 30px;
        text-align: center;
        width: 20%;

        &:not(:last-child) {
            border-right: 1px solid #eaeaea;
        }

        .account-performance__metric--value {
            color: #000000;
            font-size: 20px;
            font-weight: 500;
        }

        .account-performance__metric--text {
            display: block;
        }
    }

    @media screen and (max-width: 1500px) {
        .between-md-lg {
            flex: 0 0 100%;
        }
    }

    @media screen and (max-width: 1200px) {
        .account-performance__metric--normal {
            width: 100%;

            &:not(:last-child) {
                border: none;
                border-bottom: 1px solid #eaeaea;
            }
        }
    }
</style>

<script>
  import { mapGetters } from 'vuex'
  import hasIntegration from '@/mixins/integrations/hasIntegration'
  import datepickerMixin from '@/app/datepicker/datepicker.mixin'

  export default {
    mixins: [datepickerMixin, hasIntegration],
    name: 'FacebookAdsOverview',
    data () {
      return {
        neededIntegrations: ['Facebook ads'],
        visible: ['facebook'],
        insights: null,
        accountSpendLoaded: false
      }
    },

    watch: {
      metrics: {
        handler: 'load',
        immediate: true
      }
    },

    computed: {
      ...mapGetters('facebookAds', {
        metrics: 'getMetrics'
      }),

      organizationColor () {
        return {
          color: `${$org('colors.standard.card.backgroundMock')} !important`
        }
      },
      organizationBackgroundColor () {
        return { backgroundColor: $org('colors.standard.card.background') }
      },
      spend () {
        if (!this.insights) {
          return 12.500
        }
        return this.insights.spend
      }
    },
    methods: {
      async load () {
        if (!this.hasHealthyIntegration('Facebook ads')) {
          return
        }

        this.accountSpendLoaded = false
        this.insights = await this.$store.dispatch('facebookAds/accountInsights')
        this.accountSpendLoaded = true
      }
    }
  }
</script>
